import React, {  useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import classes from './classes.module.scss';
import  withPGTranslation  from '../../config/withPGTranslation';
import { SvgIcon } from '../../../common/sprites';
import Autocomplete from './autocomplete';
import { onHeaderSearchClick } from '../../config/util';
import { useCurrentPath } from '../routes/hooks/useCurrentPath';
import { appRoutes } from '../../config/app_routes';

const innerSearchKinds = {
  button: 'button',
  input:'input'
};
const getInnerSearchItemDisplay = (showHeaderSearchLine, kind) => {
  if (kind === innerSearchKinds.button) {
    return { display: showHeaderSearchLine ? 'none' : 'flex' };
  }
  return { display: showHeaderSearchLine ? 'flex' : 'none' };
};

function HeaderSearch({ t }) {
  const currentPath = useCurrentPath();
  const searchInputRef = useRef();
  const [showHeaderSearchLine, setShowHeaderSearchLine] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState(
    queryString.parse(currentPath.search).query
  );
  const [shouldCloseAutocomplete, setShouldCloseAutocomplete] = useState(false);

  useEffect(() => {
    setSearchInputValue(queryString.parse(currentPath.search).query);
  }, [currentPath.search]);

  useEffect(() => {
    if ((searchInputRef || {}).current) searchInputRef.current.focus();
  }, [showHeaderSearchLine]);

  const onSearch = (e) => {
    e.preventDefault();
    setShouldCloseAutocomplete(true);
    onHeaderSearchClick({
      searchInputRef, setSearchInputValue, t
    });
  };

  const searchInputValueChange = (e) => {
    setSearchInputValue(e.target.value);
    if (shouldCloseAutocomplete) {
      setShouldCloseAutocomplete(false);
    }
  };

  const headerSearchButtonClick = () => {
    setShowHeaderSearchLine(true);
  };

  const headerSearchLineCloseButtonClick = () => {
    onHeaderSearchClick({
      searchInputRef,
      setSearchInputValue,
      isSearchLineCloseButtonClick: true
    });
    setShowHeaderSearchLine(false);
  };

  if (currentPath.routeKey === appRoutes.home) return null;

  return (
    <div data-testid="header-search" className={ classes.headerSearchMainContainer } suppressHydrationWarning>
      <button
        data-testid="search-button"
        suppressHydrationWarning
        type="button"
        className={ classes.headerSearchButton }
        onClick={ headerSearchButtonClick }
        style={ getInnerSearchItemDisplay(showHeaderSearchLine, innerSearchKinds.button) }
      >
        <SvgIcon className={ classes.headerSearchButtonImg } id="black_search_icon" size={ 20 } />
      </button>
      <div
        data-testid="input-search-container"
        suppressHydrationWarning
        className={ classes.headerSearchLineContainer }
        style={ getInnerSearchItemDisplay(showHeaderSearchLine, innerSearchKinds.input) }
      >
        <form onSubmit={ onSearch }>
          <div className={ classes.headerSearchLineInputContainer }>
            <div className={ classes.headerSearchLineSearchIconAndInputContainer }>
              <SvgIcon className={ classes.headerSearchGreyIcon } id="gray_search_icon" size={ 20 } />
              <div className={ classes.headerSearchLineForm }>
                <input
                  data-testid="search-input"
                  type="text"
                  ref={ searchInputRef }
                  value={ searchInputValue || '' }
                  onChange={ searchInputValueChange }
                  className={ classes.headerSearchLineInput }
                  placeholder={ t('search_placeholder') }
                  autoComplete="off"
                />
              </div>
            </div>
            <div className={ classes.headerSearchLineDivider } />
          </div>
          <div className={ classes.headerSearchLineSearchCloseButtonContainer }>
            <button
              type="submit"
              className={ classes.headerSearchLineButton }
            >
              { t('search_button_title') }
            </button>
            <button
              data-testid="close-search-button"
              type="button"
              className={ classes.headerSearchLineCloseButton }
              onClick={ headerSearchLineCloseButtonClick }
            >
              <SvgIcon className={ classes.headerSearchLineCloseButtonImg } id="close_icon" />
            </button>
          </div>
        </form>
        <Autocomplete t={ t } query={ searchInputValue } clickSource="header autocomplete" className={ classes.autocompleteHeaderSearch } shouldClose={ shouldCloseAutocomplete } />
      </div>
    </div>
  );
}

HeaderSearch.propTypes = {
  t:PropTypes.func.isRequired
};

export default withPGTranslation(HeaderSearch);
